import {useState} from "react";


const ROIReportConfigurator = (props) => {

    const showBarChart = props.showBarChart;
    const setShowBarChart = props.setShowBarChart;
    const showGraphical = props.showGraphical;
    const setShowGraphical = props.setShowGraphical;
    const showTabular = props.showTabular;
    const setShowTabular = props.setShowTabular;
    const showSummary = props.showSummary;
    const setShowSummary = props.setShowSummary;

    const [reportName, setReportName] = useState("");
    const [coverPages, setCoverPages] = useState(true);
    const [introduction, setIntroduction] = useState(true);
    const [debrief, setDebrief] = useState(true);
    const [backPage, setBackPage] = useState(true);

    const handleSlider = (ev) => {
        if (!ev) return;
        let id = ev.currentTarget.id
        switch (id) {
            case '1': setCoverPages(!coverPages); break;
            case '2': setIntroduction(!introduction); break;
            case '3': setDebrief(!debrief); break;
            case '4': setShowBarChart(!showBarChart); break;
            case '5': setShowGraphical(!showGraphical); break;
            case '6': setShowTabular(!showTabular); break;
            case '7': setShowSummary(!showSummary); break;
            case '8': setBackPage(!backPage); break;
            default: break;
        }
    }

    const handleSubmit = () => {
        let body = {
            "name": reportName,
            "cover_pages": coverPages,
            "introduction": introduction,
            "debrief": debrief,
            "pillars": false,
            "next_steps": false,
            "back_page": backPage
        }
        props.saveConfig(body);
        props.generate();
    }

    return (
        <>
            <div className="page-mask" onClick={props.close}/>
            <div className="report-configure-page roireport">
                <div className="report-configure-header">
                    <div className="report-configure-title col">Report Configurator</div>
                </div>
                <div className="report-configure-description-container">
                    <div className="report-configure-description">
                        This configuration tool enables you to include or exclude components rendered into the PDF for
                        you to share with your clients and their teams.
                    </div>
                    <div className="report-configure-description">
                        You report will be generated server side and available in the Reports page for you to open
                        or download.
                    </div>
                </div>
                <div className="field-input">
                    <div className="label">Report Name</div>
                    <div className="field-input-entry">
                        <input className="report-input" type="text" value={reportName}
                               onChange={ev => setReportName(ev.target.value)}
                        />
                    </div>
                </div>
                <div className="report-configure-options-container">
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Report Title Page</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={coverPages ? "slider-container on" : "slider-container off"}
                                     id="1" onClick={handleSlider}>
                                    <div className={coverPages ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Introduction to PERILL</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={introduction ? "slider-container on" : "slider-container off"}
                                     id="2" onClick={handleSlider}>
                                    <div className={introduction ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Interpreting & Debriefing Guidance</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={debrief ? "slider-container on" : "slider-container off"}
                                     id="3" onClick={handleSlider}>
                                    <div className={debrief ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Percentage Over Time Overview Card</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showBarChart ? "slider-container on" : "slider-container off"}
                                     id="4" onClick={handleSlider}>
                                    <div className={showBarChart ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Performance % Change by Pillar</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showGraphical ? "slider-container on" : "slider-container off"}
                                     id="5" onClick={handleSlider}>
                                    <div className={showGraphical ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Graphical View: Team Performance Change (%) by Pillar</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showTabular ? "slider-container on" : "slider-container off"}
                                     id="6" onClick={handleSlider}>
                                    <div className={showTabular ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Numerical View: Team Performance Change (%) by Pillar</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={showSummary ? "slider-container on" : "slider-container off"}
                                     id="7" onClick={handleSlider}>
                                    <div className={showSummary ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Coach Performance Summary</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={backPage ? "slider-container on" : "slider-container off"}
                                     id="8" onClick={handleSlider}>
                                    <div className={backPage ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="report-configure-submit-container">
                    <div className={`report-configure-submit link ${reportName ? "active" : "disabled"}`}
                         onClick={reportName ? handleSubmit : null}>Generate Report</div>
                </div>
            </div>
        </>
    )
}

export default ROIReportConfigurator